import { hideSwatchDropdown } from './swatch_selector';

function customSelector() {
  const selectorWrappers = document.querySelectorAll(
    '.product__selector-wrapper',
  );
  const customSelectorWrappers = document.querySelectorAll(
    '.product__custom-selector-wrapper',
  );
  const sizeGuideWrapper = document.querySelector('.size-guide-wrapper');

  function custom_populateOptions(
    options,
    customSelectorDropdown,
    customSelectorSelectedValue,
  ) {
    if (options && customSelectorDropdown && customSelectorSelectedValue) {
      let selectedOptionIndex = null;

      options.forEach((option, option_index) => {
        const customOption = document.createElement('div');
        customOption.classList.add('product__custom-selector__dropdown-item');
        customOption.textContent = option.textContent;
        customSelectorDropdown.insertAdjacentElement('beforeend', customOption);

        // update selected option in custom selector on page load
        if (option.getAttribute('selected')) {
          if (
            customSelectorSelectedValue.textContent
              .toLowerCase()
              .includes('size')
          ) {
            customSelectorSelectedValue.textContent = `SIZE ${option.textContent}`;
          } else {
            customSelectorSelectedValue.textContent = option.textContent;
          }
          selectedOptionIndex = option_index;
        }
      });

      // indicate selected custom option
      const customOptions = document.querySelectorAll(
        '.product__custom-selector__dropdown-item',
      );
      customOptions.forEach((cOption, cOption_index) => {
        cOption.classList.remove('selected');
        if (cOption_index == selectedOptionIndex) {
          cOption.classList.add('selected');
        }
      });

      return customSelectorDropdown.querySelectorAll(
        '.product__custom-selector__dropdown-item',
      );
    }
  }

  function custom_triggerSelectEvent(
    customOptions,
    options,
    selector,
    customSelectorSelectedValue,
    customSelectorDropdown,
    customSelectorIcon,
  ) {
    if (
      customOptions &&
      options &&
      selector &&
      customSelectorSelectedValue &&
      customSelectorDropdown &&
      customSelectorIcon
    ) {
      customOptions.forEach((customOption, customOption_index) => {
        customOption.addEventListener('click', (e) => {
          // mimic select event
          options[customOption_index].selected = true;
          selector
            .closest('variant-selects.product__variant-selector-wrapper')
            .dispatchEvent(new Event('change'), { bubbles: true });

          // update selected option in custom selector
          if (
            customSelectorSelectedValue.textContent
              .toLowerCase()
              .includes('size')
          ) {
            customSelectorSelectedValue.textContent = `SIZE ${options[customOption_index].textContent}`;
          } else {
            customSelectorSelectedValue.textContent =
              options[customOption_index].textContent;
          }

          // indicate selected custom option
          customOptions.forEach((cOption) => {
            cOption.classList.remove('selected');
          });
          customOption.classList.add('selected');

          custom_toggleDropdown(customSelectorDropdown, customSelectorIcon);
        });
      });
    }
  }

  function original_removeElement(element) {
    if (element) {
      element.style.display = 'none';
    }
  }

  function custom_toggleDropdown(customSelectorDropdown, customSelectorIcon) {
    if (customSelectorDropdown && customSelectorIcon) {
      if (customSelectorDropdown.classList.contains('active')) {
        customSelectorDropdown.classList.remove('active');
        customSelectorIcon.style.transform = 'rotate(0deg)';
      } else {
        customSelectorDropdown.classList.add('active');
        customSelectorIcon.style.transform = 'rotate(180deg)';
      }
    }
  }

  function custom_closeDropdown(customSelectorDropdown, customSelectorIcon) {
    if (customSelectorDropdown && customSelectorIcon) {
      if (customSelectorDropdown.classList.contains('active')) {
        customSelectorDropdown.classList.remove('active');
        customSelectorIcon.style.transform = 'rotate(0deg)';
      }
    }
  }

  selectorWrappers.forEach((selectorWrapper, selectorWrapper_index) => {
    // original selector variables
    const selector = selectorWrapper.querySelector('select');
    const options = selectorWrapper.querySelectorAll('option');

    // custom selector variables
    const customSelectorWrapper = customSelectorWrappers[selectorWrapper_index];
    const customSelectorSelectedMain = customSelectorWrapper?.querySelector(
      '.product__custom-selector__main',
    );
    const customSelectorSelectedValue = customSelectorWrapper?.querySelector(
      '.product__custom-selector__main-selected-value',
    );
    const customSelectorDropdown = customSelectorWrapper?.querySelector(
      '.product__custom-selector__dropdown',
    );
    const customSelectorIcon = customSelectorWrapper?.querySelector(
      '.product__custom-selector__main-icon-container',
    );
    const isOneSize = customSelectorWrapper?.getAttribute('data-onesize');

    const customOptions = custom_populateOptions(
      options,
      customSelectorDropdown,
      customSelectorSelectedValue,
    );
    custom_triggerSelectEvent(
      customOptions,
      options,
      selector,
      customSelectorSelectedValue,
      customSelectorDropdown,
      customSelectorIcon,
    );

    customSelectorSelectedMain?.addEventListener('click', () => {
      custom_toggleDropdown(customSelectorDropdown, customSelectorIcon);
    });

    // remove original selector
    original_removeElement(selectorWrapper);

    // remove 'custom selector' and 'size guide' if product is one size
    if (isOneSize == 'true') {
      original_removeElement(
        selector.closest('variant-selects.product__variant-selector-wrapper'),
      );
      original_removeElement(sizeGuideWrapper);
    }
  });

  function closeCustomDropdownWhenClickedOutside(customSelectorWrappers_param) {
    if (customSelectorWrappers_param) {
      window.addEventListener('click', (e) => {
        if (
          !e.target.closest('.product__custom-selector-wrapper') &&
          !e.target.closest('.product-option-color')
        ) {
          customSelectorWrappers_param.forEach((selectorW, selectorW_index) => {
            const customSelectorDropdown = selectorW?.querySelector(
              '.product__custom-selector__dropdown',
            );
            const customSelectorIcon = selectorW?.querySelector(
              '.product__custom-selector__main-icon-container',
            );

            custom_closeDropdown(customSelectorDropdown, customSelectorIcon);
          });
          hideSwatchDropdown();
        }
      });
    }
  }
  closeCustomDropdownWhenClickedOutside(customSelectorWrappers);
}

export { customSelector as default };
